import type { LocationFilter } from "generated/graphql";

export const flattenGeometryFilter = (
  filter: LocationFilter["geometry"],
): LocationFilter["geometry"] =>
  filter == null
    ? undefined
    : {
        null: filter.null,
      };
